import React from 'react'
import translatePath from './translatePath'

export const defaultX = 0
export const defaultY = 0
export const width = 550
export const height = 1150

export const path = [
  'M475,0 C516.421356,0 550,33.5786438 550,75 C550,116.007143 517.089571,149.327643 476.240262,149.989952 L475,150 L150,150 L150,875 C150,943.345238 204.850715,998.879405 272.932896,999.983254 L275,1000 C343.345238,1000 398.879405,945.149285 399.983254,877.067104 L400,875 L400,275 C400,233.578644 433.578644,200 475,200 C516.007143,200 549.327643,232.910429 549.989952,273.759738 L550,275 L550,875 C550,1026.87831 426.878306,1150 275,1150 C124.640477,1150 2.46530954,1029.32843 0.0368421431,879.547628 L0,875 L0,75 C0,33.9928573 32.9104288,0.672357147 73.7597379,0 L475,0 Z',
  'M350,200 L350,875 L349.989952,876.240262 C349.334266,916.681078 316.670287,949.340998 276.227883,949.990152 L275,950 L273.759738,949.989952 C233.318922,949.334266 200.659002,916.670287 200.009848,876.227883 L200,875 L200,200 L350,200 Z'
]

export const getPath = (x, y) => translatePath(path, defaultX, defaultY, x, y)

const T = () => (
  <symbol id="t" viewBox={`${defaultX} ${defaultY} ${width} ${height}`}>
    <path d={path.join(' ')} />
  </symbol>
)

export default T
